import { gql } from '@apollo/client';

export type SplitTutorialVideoType = 'ALGO' | 'MAP';

/** 教学视频语言；不传或该语言未配置时后端回退中文 */
export type SplitTutorialVideoLanguage = 'ZH' | 'EN' | 'ES';

export interface GetSplitTutorialVideoUrlResponse {
    getSplitTutorialVideoUrl: string;
}

export interface GetSplitTutorialVideoUrlVariables {
    videoType: SplitTutorialVideoType;
    language?: SplitTutorialVideoLanguage;
}

/**
 * 获取分单教学视频的短时签名 URL（5 分钟过期，仅登录可访问，防分享）。
 */
export const GET_SPLIT_TUTORIAL_VIDEO_URL = gql`
    query GetSplitTutorialVideoUrl($videoType: SplitTutorialVideoType!, $language: SplitTutorialVideoLanguage) {
        getSplitTutorialVideoUrl(videoType: $videoType, language: $language)
    }
`;
